import { Navigate, useLocation } from 'react-router'

import { DASHBOARD_URL } from 'features/dashboard/paths'
import { DASHBOARDS_2_URL } from 'src/features/dashboards-v2/paths'

// Dashboards v1 (/custom-dashboards[/:id][/edit], and the v1 shared-link
// slug) is dead — every v1 URL shape just redirects to its v2 equivalent.
// Kept (rather than a 404) because saved views and external links still
// mint v1 URLs. Used both for the FeatureGuardLayout-protected list/view/edit
// routes and for the public shared-link route (recipients are anonymous, not
// subject to the project's feature flags, so this must work unconditionally).
export const RedirectToDashboardsV2 = (): JSX.Element => {
  const location = useLocation()
  const redirectPath = location.pathname.replace(
    `/${DASHBOARD_URL}`,
    `/${DASHBOARDS_2_URL}`,
  )
  return <Navigate to={`${redirectPath}${location.search}`} replace />
}
